import { MobDef } from '../mob';
import { BlockId } from '@shared/block-ids';

export const ZOMBIE_DEF: MobDef = {
  name: 'Zombie',
  width: 0.6,
  height: 1.8,
  health: 20,
  speed: 2.3,
  hostile: true,
  color: 0x4a7a4a,
  bodyColor: 0x3a6a3a,
  detectionRange: 16,
  attackDamage: 3,
  attackRange: 1.5,
  drops: [
    { id: BlockId.IRON_ORE, min: 0, max: 2 },
  ],
};
